import { SessionStatus } from './../../models/class/session/session';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OfferSession, SessionTest, SessionByDate } from 'app/shared/models/class/session/session';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  sessions: SessionByDate[] = [];
  sessionsListChanged = new Subject<SessionByDate[]>();

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getSessionByOffer(offerKey: number): Observable<OfferSession[]> {
    return this.http.get<OfferSession[]>(`${environment.apiUrl}/Session/${offerKey}`);
  }

  getSessionStatus(): Observable<SessionStatus[]> {
    return this.http.get<SessionStatus[]>(`${environment.apiUrl}/Session/Status`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addSessionToOffer(session: OfferSession) {
    return this.http.post(`${environment.apiUrl}/Session`, session);
  }

  getSessionsByClub(clubCode: string, startDate, endDate): Observable<SessionByDate[]> {
    this.sessions = [];
    const params = {
      clubCode: clubCode,
      startDate: startDate,
      endDate: endDate
    };
    return this.http.post<SessionByDate[]>(`${environment.apiUrl}/Session/SessionsByDate`, params)
      .pipe(
        tap((sessions) => {
          sessions.map(session => {
            let sessionFormated: SessionByDate = {
              dateLib: session.dateLib,
              offerName: session.offerName,
              sessionEndDate: moment(session.sessionEndDate).utc().format('DD/MM/YYYY HH:mm'),
              sessionKey: session.sessionKey,
              sessionStartDate: moment(session.sessionStartDate).utc().format('DD/MM/YYYY HH:mm'),
              bookedSessionTrainees: session.bookedSessionTrainees,
              offerKey: session.offerKey,
              quantity: session.quantity,
              status: session.status,
              rating: session.rating,
              ratingTotal: session.ratingTotal
            }

            this.sessions.push(sessionFormated)

          })

          this.sessionsListChanged.next([...this.sessions]);
        }))
  }


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateSessionToOffer(session: OfferSession) {
    return this.http.post(`${environment.apiUrl}/Session`, session);
  }

  activateOrDeactivateSessionOffer(sessionKey: number, isActive: boolean) {
    return this.http.put(`${environment.apiUrl}/Session/ActivateSession/${sessionKey}/${isActive}`, null);
  }

  changeStatus(sessionKey, bookedSessionStatusKey) {
    return this.http.put(`${environment.apiUrl}/Session/StatusChange/${sessionKey}/${bookedSessionStatusKey}`, null);
  }
}
